import { useBlockingRouter } from './useBlockingRouter';
import { useMemo } from 'react';
import { Routes } from '../config/routes';

const signUpPathNames: RegExp[] = [
	new RegExp( `^${ Routes.OrgOnboarding }/[^/]+$` ),
	new RegExp( `^${ Routes.ClientOnboarding }/[^/]+$` ),
	new RegExp( `^${ Routes.OrgMemberSignUp }/[0-9]+$` ),
];

export default function useIsOnBoardingRoute() {
	const router = useBlockingRouter();

	const isOnBoardingRoute = useMemo( () => {
		const pathname = router.pathname;
		return (
			!!router?.query?.verificationToken ||
			signUpPathNames.some( ( pattern ) => pattern.test( pathname ) )
		);
	}, [ router ] );

	return isOnBoardingRoute;
}
